"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserViewStatus = exports.USER_VIEW_STATUS = void 0;
exports.USER_VIEW_STATUS = {
    NONE: { displayName: 'None', value: 0 },
    NEW: { displayName: 'New', value: 1 },
    UPDATED: { displayName: 'Updated', value: 2 },
};
var getUserViewStatus = function (userViewStatus) {
    return Object.values(exports.USER_VIEW_STATUS).find(function (status) { return status.value === userViewStatus; }).displayName;
};
exports.getUserViewStatus = getUserViewStatus;
